import useIsITEInternal from 'dashboard/apps/InquiryTemplateEditor/hooks/useIsITEInternal';
import ConfirmationModal from 'dashboard/components-lib/ConfirmationModal';
import { InquiryTemplateVersion } from 'dashboard/models/inquiry-template-version';
import { CustomerTier, Organization } from 'dashboard/models/organization';

const PUBLISH_DEFAULT_TEXT =
  'Publishing will affect any future production inquiries made with this template.';

const BLOCK_PUBLISH_COMPLIANCE_TEXT =
  'This template now requires additional biometric disclosures, please reach out to the Persona team for more details.';
const BLOCK_PUBLISH_COMPLIANCE_TEXT_T3 =
  'This template now requires additional biometric disclosures, please reach out to the Persona team at support@withpersona.com for more details.';
const BLOCK_PUBLISH_ADMIN_APPROVAL_REQUIRED =
  'This template requires approval by a Persona administrator before publishing, please reach out to your Persona representative to obtain approval before proceeding.';

export interface PublishInquiryTemplateVersionModalProps {
  inquiryTemplateVersion: InquiryTemplateVersion;
  organization: Organization;
  hidePublishModal: () => void;
  handleRolloutAndPublish: () => void;
}
export const PublishInquiryTemplateVersionModal = ({
  inquiryTemplateVersion,
  organization,
  hidePublishModal,
  handleRolloutAndPublish,
}: PublishInquiryTemplateVersionModalProps) => {
  // self-serve BIPA handling
  const isInternalUser = useIsITEInternal();
  const { 'biometric-auto-migration-status': autoMigrationStatus } =
    inquiryTemplateVersion.attributes;
  const isTier3 = organization.attributes['customer-tier'] === CustomerTier.Tier3;

  if (autoMigrationStatus === 'not_migratable') {
    return (
      <ConfirmationModal
        cancelAction={hidePublishModal}
        confirmAction={hidePublishModal}
        cancelActionText='Cancel'
        confirmActionText='Ok'
        header='Publishing blocked'
        confirmButtonType='primary'
      >
        {isTier3 ? BLOCK_PUBLISH_COMPLIANCE_TEXT_T3 : BLOCK_PUBLISH_COMPLIANCE_TEXT}
      </ConfirmationModal>
    );
  }

  if (!isInternalUser && !inquiryTemplateVersion.attributes['publish-approved']) {
    return (
      <ConfirmationModal
        cancelAction={hidePublishModal}
        confirmAction={hidePublishModal}
        confirmActionText='Ok'
        cancelActionText='Cancel'
        header='Approval required'
        confirmButtonType='primary'
      >
        {BLOCK_PUBLISH_ADMIN_APPROVAL_REQUIRED}
      </ConfirmationModal>
    );
  }

  return (
    <ConfirmationModal
      cancelAction={hidePublishModal}
      confirmAction={handleRolloutAndPublish}
      cancelActionText='Cancel'
      confirmActionText='Publish'
      header='Publish changes?'
      confirmButtonType='primary'
    >
      {PUBLISH_DEFAULT_TEXT}
    </ConfirmationModal>
  );
};
